import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Container from '../common/Container';
import CloudinaryImage from '../common/CloudinaryImage';

export default function DevopsSoftWare({ data, ishome, isStaff, isHDcolor }) {
  const TabFirst = data?.Tools?.map(btn => btn?.text);

  const [activeTab, setActiveTab] = useState(TabFirst[0]);

  const handleTab = item => {
    setActiveTab(item.text);
  };

  return (
    <div className="">
      <Container>
        <div
          className={`w-full ${isStaff && 'bg-[#E8F1FF] border border-[#B7B7B7] rounded-[40px] py-12'}`}
        >
          <div
            className={
              data?.titleEditor
                ? `xl:mb-[34px] mb-[30px]`
                : data?.title
                  ? `xl:mb-[34px] mb-[30px]`
                  : ''
            }
          >
            {data?.titleEditor ? (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`text-center font-[400] xl:text-[55px] md:text-[32px] text-[25px] title_hd leading-tight mb-3`}
                source={data?.titleEditor}
              >
                {data?.titleEditor}
              </ReactMarkdown>
            ) : data?.title ? (
              <h2
                className={`xl:text-[48px] md:text-[32px] text-[26px] ${isHDcolor ? 'text-[#fff]' : 'text-[#000]'} leading-tight text-center font-[800] mb-3`}
              >
                {data?.title}
              </h2>
            ) : (
              <h2 className="xl:text-[48px] md:text-[32px] text-[26px] title_hd leading-tight text-center mb-[30px] font-[400] mb-3">
                Our DevOps Engineers
                <span className="font-[700]">Software Toolbox</span>
              </h2>
            )}
            {data?.subTitle && (
              <p
                className={`${isHDcolor ? 'text-[#fff]' : 'text-[#000]'} lg:text-[20px] text-[16px] font-[400] text-center max-w-[1100px] mx-auto`}
              >
                {data?.subTitle}
              </p>
            )}
            {data?.descriptionEditor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`${isHDcolor ? 'text-[#fff]' : 'text-[#000]'} lg:text-[20px] text-[16px] font-[400] text-center max-w-[1100px] mx-auto`}
                source={data?.descriptionEditor}
              >
                {data?.descriptionEditor}
              </ReactMarkdown>
            )}
          </div>
          <ul className="flex flex-wrap justify-center mb-[50px] w-[100%] rounded-[10px] lg:gap-4 gap-1">
            {data?.Tools?.map(item => (
              <li
                key={item?.id}
                className={`cursor-pointer md:text-[16px] text-[14px] rounded-[40px] ${isStaff && activeTab === item?.text ? 'bg-[#FFA030]' : activeTab === item?.text ? 'bg-[#0050D5] text-[#FFFFFF] font-[500]' : 'bg-[#383838] text-[#ffffffe0] font-[400]'}`}
              >
                <button
                  onClick={() => handleTab(item)}
                  className="py-[6px] px-[25px] block"
                >
                  {item?.text}
                </button>
              </li>
            ))}
          </ul>
          <div
            className={`flex ${isStaff ? 'lg:w-[90%]' : 'lg:w-[100%]'} w-[100%] flex-wrap justify-center mx-auto`}
          >
            {data?.Software?.map(
              tec =>
                activeTab === tec?.Key && (
                  <div
                    key={tec?.id}
                    className={`${ishome ? 'bg-[#FFFFFF17]' : 'shadow-[0px_0px_2px_0px_#00000040]'} transation-custom hover:-translate-y-3 ${isStaff ? 'xl:w-[16%] lg:w-[21%] md:w-[29%] w-[46%]' : 'xl:w-[16%] md:w-[29%] w-[46%]'} mx-[2%] lg:mb-8 mb-4 p-[25px] text-center rounded-[8px]`}
                  >
                    {tec?.icon?.data && (
                      <CloudinaryImage
                        backendImgUrl={tec?.icon?.data?.attributes?.url}
                        alt={tec?.icon?.data?.attributes?.alternativeText}
                        type="icon"
                        className={'lg:w-[90px] w-[40px] mx-auto mb-3'}
                      />
                    )}
                    <p className="text-[#fff] md:text-[20px] text-[14px] font-[400]">
                      {tec?.text}
                    </p>
                  </div>
                )
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}
